import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

interface IProps {
  simpleMode: boolean;
}
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '100%',
    margin: '0 auto',
    display: 'flex',
    maxWidth: '800px',
    flexDirection: 'column',
    justifyContent: (props: IProps) => (props.simpleMode ? 'unset' : 'center'),
    padding: (props: IProps) => (props.simpleMode ? '10px' : '30px'),
    boxSizing: 'border-box',
    gap: '15px',
    '& img': {
      margin: '0 auto',
      width: (props: IProps) => (props.simpleMode ? '100%' : '40vw'),
      maxWidth: '500px',
      objectFit: 'contain',
    },
    background: theme.palette.secondary.main,
  },
  form: {
    background: theme.palette.secondary.main,
    height: '100%',
  },
  external: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    justifyItems: 'center',
    gap: (props: IProps) => (props.simpleMode ? '10px' : '80px'),
    '& svg': {
      width: '250px !important',
      maxHeight: '25px !important',
      cursor: 'pointer',
      padding: '10px 30px',
      borderRadius: '10px',
      backgroundColor: '#B2B2B217',
      filter: theme.palette.mode === 'dark' ? 'brightness(100)' : undefined,
      '& path': {
        filter: theme.palette.mode === 'dark' ? 'brightness(100) contrast(0)' : undefined,
      },
    },
  },
  externalDisabled: {
    '& svg': {
      cursor: 'default',
      opacity: 0.5,
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      filter:
        theme.palette.mode === 'dark' ? 'brightness(100) grayscale(1) contrast(100)' : undefined,
    },
  },
  divider: {
    margin: (props: IProps) => (props.simpleMode ? 'unset' : '20px 16px !important'),
  },
  simplified: {
    flexDirection: 'column',
    '& svg': {
      width: '100%',
      cursor: 'pointer',
      padding: '10px',
    },
  },
  slimForm: {
    height: '100%',
    overflow: 'hidden',
  },
  slimContainer: {
    display: 'grid',
    gridTemplateColumns: '35% 1fr',
    padding: '10px',
    gap: '8px',
    maxWidth: '100%',
    justifyContent: 'unset',
    alignItems: 'center',
    position: 'relative',
    '& > *': {
      gridColumn: '2',
    },
    '& .MuiInputBase-input': {
      padding: '8px 10px !important',
      fontSize: '13px',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
    },
    '& .MuiButton-root': {
      fontSize: '12px',
      padding: '6px 16px',
    },
  },
  slimLogoColumn: {
    gridColumn: '1',
    gridRow: '1 / span 20',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '35%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      width: '80% !important',
      maxWidth: '250px !important',
      transform: 'translate(0px, -50%)',
    },
  },
  slimExternal: {
    gap: '10px !important',
    '& svg': {
      width: '100% !important',
      maxWidth: '150px !important',
      maxHeight: '20px !important',
      padding: '6px 12px !important',
    },
  },
  slimDivider: {
    margin: '4px 0 !important',
  },
}));

export default useStyles;
